import { useEffect, useRef } from "react";
import { gsap, formatCount, parseCount } from "./casestudy/csMotion.js";

/** Numeric stats count up from zero when `run` flips on; text stats just show. */
export default function CountUp({ value, run, duration = 1.6 }) {
  const ref = useRef(null);
  const parsed = parseCount(value);

  useEffect(() => {
    const el = ref.current;
    if (!el || !parsed) return;
    if (!run) {
      el.textContent = formatCount(0, parsed);
      return;
    }
    const obj = { n: 0 };
    const tween = gsap.to(obj, {
      n: parsed.to,
      duration,
      ease: "power3.out",
      onUpdate: () => (el.textContent = formatCount(obj.n, parsed)),
    });
    return () => tween.kill();
  }, [run, parsed?.to]); // eslint-disable-line react-hooks/exhaustive-deps

  return <span ref={ref}>{value}</span>;
}
